import { render } from "./SalaryModal.vue?vue&type=template&id=83ed58c4"
import script from "./SalaryModal.vue?vue&type=script&lang=js"
export * from "./SalaryModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__